var _style, _defs, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_205_2228_00000160178650249966790120000005248048908573495948_);}\r\n\t.st2{fill:#0E9384;}\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 17.1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 17.1,
    id: "mask0_205_2228_00000160178650249966790120000005248048908573495948_"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.5,13.5h7v-1h-7V13.5z M6.5,10.5h11v-1h-11V10.5z M6.5,7.5h11v-1h-11V7.5z M3,20.1V4.6 c0-0.5,0.2-0.8,0.5-1.2S4.2,3,4.6,3h14.8c0.5,0,0.8,0.2,1.2,0.5S21,4.2,21,4.6v10.8c0,0.5-0.2,0.8-0.5,1.2S19.8,17,19.4,17H6.1 L3,20.1z M5.7,16h13.7c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.4V4.6c0-0.2-0.1-0.3-0.2-0.4C19.7,4.1,19.5,4,19.4,4H4.6 C4.5,4,4.3,4.1,4.2,4.2C4.1,4.3,4,4.5,4,4.6v13L5.7,16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsIcon);
export default __webpack_public_path__ + "static/media/comments-icon.3eeefa314a13dd8fbcc85f1540138ec9.svg";
export { ForwardRef as ReactComponent };